import { defineMessages } from 'react-intl';

export const messages: {
	betweenCharacters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	betweenWords: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactCharacters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactWords: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumCharacters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumWords: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumCharacters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumWords: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	regexCustomMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	regexDefaultMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	regexInvalidMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	regexUnsupportedMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betweenCharacters: {
		id: 'proforma-form-renderer.common.utils.validators.text.between-characters',
		defaultMessage:
			'Must be between {minimum} and {maximum, plural, one {# character} other {# characters}}.',
		description: 'Validation message for field with character length between a range.',
	},
	betweenWords: {
		id: 'proforma-form-renderer.common.utils.validators.text.between-words',
		defaultMessage:
			'Must be between {minimum} and {maximum, plural, one {# word} other {# words}}.',
		description: 'Validation message for field with word length between a range.',
	},
	exactCharacters: {
		id: 'proforma-form-renderer.common.utils.validators.text.exact-characters',
		defaultMessage: 'Must be exactly {minimum, plural, one {# character} other {# characters}}.',
		description: 'Validation message for field with exact character length.',
	},
	exactWords: {
		id: 'proforma-form-renderer.common.utils.validators.text.exact-words',
		defaultMessage: 'Must be exactly {minimum, plural, one {# word} other {# words}}.',
		description: 'Validation message for field with exact word length.',
	},
	maximumCharacters: {
		id: 'proforma-form-renderer.common.utils.validators.text.maximum-characters',
		defaultMessage: 'Must be less than {maximum, plural, one {# character} other {# characters}}.',
		description: 'Validation message for field with maximum character length.',
	},
	maximumWords: {
		id: 'proforma-form-renderer.common.utils.validators.text.maximum-words',
		defaultMessage: 'Must be less than {maximum, plural, one {# word} other {# words}}.',
		description: 'Validation message for field with maximum word length.',
	},
	minimumCharacters: {
		id: 'proforma-form-renderer.common.utils.validators.text.minimum-characters',
		defaultMessage: 'Must be more than {minimum, plural, one {# character} other {# characters}}.',
		description: 'Validation message for field with minimum character length.',
	},
	minimumWords: {
		id: 'proforma-form-renderer.common.utils.validators.text.minimum-words',
		defaultMessage: 'Must be more than {minimum, plural, one {# word} other {# words}}.',
		description: 'Validation message for field with minimum word length.',
	},
	regexCustomMessage: {
		id: 'proforma-form-renderer.common.utils.validators.text.regex-custom-message',
		defaultMessage: '{message}',
		description: 'Custom validation message for field with regex pattern.',
	},
	regexDefaultMessage: {
		id: 'proforma-form-renderer.common.utils.validators.text.regex-default-message',
		defaultMessage: 'Response does not match required pattern.',
		description: 'Default validation message for field with regex pattern.',
	},
	regexInvalidMessage: {
		id: 'proforma-form-renderer.common.utils.validators.text.regex-invalid-message',
		defaultMessage: 'The regex pattern on this field is invalid. Answer unable to be validated.',
		description: 'Validation message for field with invalid regex pattern.',
	},
	regexUnsupportedMessage: {
		id: 'proforma-form-renderer.common.utils.validators.text.regex-unsupported-message',
		defaultMessage:
			'This regex pattern is invalid. Contact your admin to fix the pattern in form settings.',
		description: 'Validation message for field with unsupported regex pattern.',
	},
});
